import { FeatureEnum } from '@/graphql/generated';
import { NavItem } from './NavItem';
import { MaturityIcon, ResultsIcon, SurveyIcon } from '@/components/icons';
import { AppRoutes } from '@/screens/AppRoutes';
import { ReactNode } from 'react';
import { usePermissionChecker } from '@/hooks/usePermissionChecker';
import { useTranslation } from '@/hooks/useTranslation';
import { useProjectContext } from '@/providers/ProjectContextProvider';
import { generatePath } from 'react-router';
import { useListReportsByEnterprise } from '@/hooks/reports/useListReportsByEnterprise';

export const useDataCollectNavItems = () => {
  const { isGranted } = usePermissionChecker();

  const { t } = useTranslation();
  const items: { key: string; element: ReactNode }[] = [];

  const enterpriseId = useProjectContext()?.enterprise?.id;
  const hasLicense = useProjectContext()?.hasLicense;

  const { reports: enterpriseReports } =
    useListReportsByEnterprise(enterpriseId);

  if (isGranted(FeatureEnum.MaturityEvaluationManagement)) {
    items.push({
      key: 'page.maturity_evaluation',
      element: (
        <NavItem
          name={t('nav:page.maturity_evaluation')}
          Icon={MaturityIcon}
          href={AppRoutes.MaturityEvaluations}
        />
      ),
    });
  }
  if (isGranted(FeatureEnum.ConsultationManagement)) {
    items.push({
      key: 'page.surveys',
      element: (
        <NavItem
          name={t('nav:page.surveys')}
          Icon={SurveyIcon}
          href={AppRoutes.Survey}
        />
      ),
    });
  }

  // TODO: display standards (and not reports) when standard page is ready
  if (isGranted(FeatureEnum.IndicatorsManagement)) {
    items.push({
      key: 'page.standards',
      element: (
        <NavItem
          name={t('nav:page.standards')}
          Icon={ResultsIcon}
          href={generatePath(AppRoutes.Reports)}
          expandable={enterpriseReports && enterpriseReports?.length > 0}
        >
          {enterpriseReports?.map((report) => (
            <NavItem
              key={report.id}
              name={t(`enum:standard.${report.standard}`)}
              href={generatePath(AppRoutes.ReportDisclosureRequirements, {
                reportId: report.id,
              })}
            />
          ))}
        </NavItem>
      ),
    });
  }

  if (isGranted(FeatureEnum.IndicatorsCollect) && hasLicense) {
    items.push({
      key: 'page.indicators_collect',
      element: (
        <NavItem
          name={t('nav:page.indicators_collect')}
          Icon={ResultsIcon}
          href={AppRoutes.IndicatorsCollect}
        />
      ),
    });
  }

  return items;
};
